import React, { useState, useRef, useEffect } from "react";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero, validaMonto, formatoMonto } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { useParams } from "react-router-dom";
import TablaPlanillaGenerada from "../tablaPlanillasGeneradas";

function GenerarPlanillaTImbre() {
  /////#####Declaracion de variables#####/////

  /////variables nativas js
  var parametros = useParams();
  var tipo = parametros.tipo;
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  var tipoplanilla =
    tipo === "TF" ? "Timbres Fiscales" : "Guia De Movilización";
  var clave = tipo === "TF" ? "idtipoagente" : "mina";
  var valor = tipo === "TF" ? "4" : true;
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const usuario = JSON.parse(localStorage.getItem("login"));

  /////variables de referencias
  const txtValorUTE = useRef();
  const txtCantidad = useRef();

  /////variables de estados
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [total, setTotal] = useState(0);
  /*     const [values, setValues] = useState({tipo: ''}); */
  const [inhabilitado, setInhabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [planillas, setPlanillas] = useState([]);

  /////#####funcion para capturar solo numeros#####/////
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      event.target.value = event.target.value;
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  /*     const onChange = (event) => {
          setValues({...values, [event.target.name]: event.target.value});
        }; */
  /////#####$$$$$#####/////

  /////#####funcion para formatear el monto#####/////
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  /////#####$$$$$#####/////

  /////#####funcion para blanquear la planilla#####/////
  const blanquearPlanilla = () => {
    txtValorUTE.current.value = "";
    txtCantidad.current.value = "";
  };
  /////#####$$$$$#####/////

  /////#####funcion para agregar la planilla a la tabla#####/////
  const agregarPlanilla = () => {
    const lista = [];
    if (txtCantidad.current.value > 0) {
      for (let i = 0; i < records.length; i++) {
        lista.push(records[i]);
      }
      lista.push({
        idusuariotimbre: idusuario,
        fechageneracion: fechaSistema,
        monto: txtValorUTE.current.value,
        cantidad: txtCantidad.current.value,
        codigoplanilla: tipo,
      });
      setRecords(lista);
      setTotal(total + parseInt(txtCantidad.current.value));
      blanquearPlanilla();
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para validar que no se repita la planilla en la tabla#####/////
  const validarPlanilla = () => {
    if (txtCantidad.current.value !== "") {
      let sigue = true;
      for (let i = 0; i < records.length; i++) {
        if (txtValorUTE.current.value === records[i].monto) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Este registro ya esta cargado en el listado",
            icono: "informacion",
          });
          sigue = false;
        }
      }
      if (sigue) {
        agregarPlanilla();
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para editar la planilla#####/////
  const editarPlanilla = (item) => {
    let element = [];
    if (txtCantidad.current.value === "") {
      for (let i = 0; i < records.length; i++) {
        if (
          records[i].monto == item.monto &&
          records[i].cantidad == item.cantidad
        ) {
          txtValorUTE.current.value = records[i].monto;
          txtCantidad.current.value = records[i].cantidad;
          setTotal(total - parseInt(records[i].cantidad));
        } else {
          element.push(records[i]);
        }
      }
      setRecords(element);
      if (element.length <= 0) {
        setTotal(0);
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Ya esta siendo editado un Registro",
        icono: "informacion",
      });
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para eliminar la planilla#####/////
  const eliminarPlanilla = (item) => {
    let element = [];
    for (let i = 0; i < records.length; i++) {
      if (records[i].monto !== item.monto) {
        element.push(records[i]);
      } else {
        setTotal(total - parseInt(records[i].cantidad));
      }
    }
    setRecords(element);
    if (element.length <= 0) {
      setTotal(0);
    }
  };
  /////#####$$$$$#####/////

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "planillatimbre";
    let orden = "idplanillatimbre desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const datos = [];
          var tip = "";

          for (let i = 0; i < response.data.length; i++) {
            tip =
              response.data[i].codigoplanilla !== null
                ? response.data[i].codigoplanilla.includes(tipo)
                : false;
            if (tip) {
              datos.push(response.data[i]);
            }
          }

          setPlanillas(datos);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  /////#####proceso para generar las planillas#####/////
  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = "";
    endpoint = `${op.conexion}/api/timbres/actualizarplanillas`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.respuesta > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.respuesta} Planillas Generadas Correctamente.`,
              icono: "exito",
            });
            SeleccionarRegistros();
          }
          setActivate(false);
          setRecords([]);
          setTotal(0);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  /////#####funcion para generar las planillas#####/////
  const generarPlanillas = () => {
    const element = [];
    for (let i = 0; i < records.length; i++) {
      for (let j = 0; j < parseInt(records[i].cantidad); j++) {
        element.push({
          idusuariotimbre: records[i].idusuariotimbre,
          fechageneracion: records[i].fechageneracion,
          monto: parseFloat(
            records[i].monto.trim().replace(/\./g, "").replace(",", ".")
          ),
          codigoplanilla: records[i].codigoplanilla,
        });
      }
    }
    let body = {
      planillas: element,
    };

    if (element.length > 0) {
      procesarRegistro(body);
    }
  };
  /////#####$$$$$#####/////

  useEffect(() => {
    SeleccionarRegistros();
  }, []);

  return (
    <div className="container-fluid px-3 py-3">
      <ul className="nav mb-3 h-25" id="ex-with-icons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#25d366" }}
            id="ex-with-icons-tab-1"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-1"
            role="tab"
            aria-controls="ex-with-icons-tabs-1"
            aria-selected="true"
          >
            <i className="fas fa-chart-pie fa-fw me-2" />
            Generar {tipoplanilla}
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#55acee" }}
            id="ex-with-icons-tab-2"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-2"
            role="tab"
            aria-controls="ex-with-icons-tabs-2"
            aria-selected="false"
          >
            <i className="fas fa-chart-line fa-fw me-2" />
            Historico {tipoplanilla}
          </a>
        </li>
      </ul>
      <div className="tab-content" id="ex-with-icons-content">
        <div
          className="tab-pane fade show active"
          id="ex-with-icons-tabs-1"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-1"
        >
          <div className="col-md-12 bg-white">
            <div className="card-body h-90 px-0 py-0">
              <div className="row">
                <div className="col-md-12 row  p-4">
                  <p className="h5 text-center">
                    <strong>Informacion General</strong>{" "}
                  </p>
                  {/*                                     <div className="col-md-12 row">
                                        <label className=" text-dark fw-bold" id="inputGroup-sizing-sm">Usuario: {usuario}</label>
                                        
                                    </div> */}
                  <div className="mx-auto px-2">
                    <hr className="dropdown-divider" />
                  </div>
                  <div className=" mt-1 row me-1 col-sm-12 d-flex justify-content-between">
                    <div className="input-group input-group-sm col-sm-4">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Valor UTE:
                      </span>
                      <input
                        type="text"
                        className="form-control text-right"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtValorUTE}
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="mx-auto px-2">
                      <hr className="dropdown-divider" />
                    </div>
                    <div className="input-group input-group-sm col-sm-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cantidad:
                      </span>
                      <input
                        type="text"
                        className="form-control text-right"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtCantidad}
                        onKeyUp={handleInputNumChange}
                        onChange={handleInputNumChange}
                      />
                    </div>
                    <div className="card-footer d-flex justify-content-center mx-1 my-3 row">
                      <button
                        type="button"
                        onClick={validarPlanilla}
                        className="col-3 mx-auto btn btn-primary btn-sm"
                      >
                        Agregar
                      </button>
                      <button
                        type="button"
                        onClick={blanquearPlanilla}
                        className="col-3 mx-auto btn btn-warning btn-sm"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body h-90 p-0">
                  <div className="container py-3 col-md-12 row">
                    <p className="h5 text-center">
                      <strong>Datos de las Planillas a Generar</strong>
                    </p>
                  </div>
                  <div className="crecords[i]rd-body col-md-12 col-sm-12 col-xl-12 col-12 d-flex justify-content-evenly">
                    <table className="table tablet-responsive table-bordered table-striped">
                      <thead style={{ fontSize: "15px" }}>
                        <tr>
                          <th className="text-center">valor</th>
                          <th className="text-center">cantidad</th>
                          <th
                            className="text-center"
                            style={{ width: "260px" }}
                          >
                            opciónes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {records &&
                          records.map((item, index) => (
                            <tr key={item} style={{ padding: "0" }}>
                              <td
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                {item.monto}
                              </td>
                              <td
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                {item.cantidad}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  padding: 0,
                                  margin: 0,
                                }}
                                className="row d-flex justify-content-between px-5 py-1"
                              >
                                <button
                                  onClick={() => editarPlanilla(item)}
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    color: "#ffffff",
                                    backgroundColor: "#0054bd",
                                  }}
                                  className="btn col-4 rounded-pill btn-sm"
                                >
                                  <i className="fa fa-edit"></i>{" "}
                                </button>
                                <button
                                  onClick={() => eliminarPlanilla(item)}
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    color: "#ffffff",
                                    backgroundColor: "#ff0000",
                                  }}
                                  className="btn col-4 rounded-pill btn-sm"
                                >
                                  <i className="fa fa-trash"></i>{" "}
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row d-flex justify-content-between px-3">
                    <div className="col-md-4 d-flex justify-content-start">
                      <label className="form-label">
                        Total Planillas:{" "}
                        <span className="text-dark">{total}</span>
                      </label>
                    </div>
                    <div className="col-md-4 d-flex justify-content-end">
                      <div className="py-4 ml-0 m-0 ">
                        <button
                          type="button"
                          onClick={generarPlanillas}
                          className="btn btn-success btn-sm rounded-pill"
                        >
                          Generar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="ex-with-icons-tabs-2"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-2"
        >
          <TablaPlanillaGenerada planillas={planillas} tipo={tipo} />
        </div>
      </div>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default GenerarPlanillaTImbre;

/////////////#####$$$$$#####/////////////////
/////#####Generar Planillas#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/components/timbres/gestionarPlanillasTimbres.js